import { Button, Card, Group, List, Loader, Stack, Text, Title } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';

// A plain list, not ticks: the run saves every part at once at the end, and a re-run keeps the old
// values on the row until then, so nothing on the row says which part is done.
const PARTS = ['Your logo', 'Your colors', 'Your font and corners', 'How your brand sounds'];

const ReadingWebsiteProgress = ({ url, onSkip, skipping }) => (
  <Card withBorder padding="lg" data-testid="reading-website">
    <Stack gap="md">
      <Group gap="sm">
        <Loader size="sm" />
        <Title order={4}>Reading your website</Title>
      </Group>
      <Text size="sm" c="dimmed">
        We are looking at {url || 'your website'} to find your logo, colors and the way you talk to customers. This
        usually takes a minute or two. You can keep using the rest of Releva meanwhile.
      </Text>
      <Stack gap={4}>
        <Text size="sm">What we are looking for:</Text>
        <List size="sm" c="dimmed">
          {PARTS.map((label) => (
            <List.Item key={label}>{label}</List.Item>
          ))}
        </List>
      </Stack>
      {onSkip && (
        <Group>
          <Button variant="subtle" onClick={onSkip} loading={skipping} rightSection={<IconArrowRight size={16} />}>
            Skip for now
          </Button>
        </Group>
      )}
    </Stack>
  </Card>
);

export default ReadingWebsiteProgress;
